import { Navigate } from "@tanstack/react-router";

import { useEnableLineAdsIntegration } from "@/features/line-ads/useEnableLineAdsIntegration";
import { LineAdsIntegrationPage } from "@/pages/applications/pages/lineAdsIntegration";

export const LineAdsIntegrationPageWrapper: React.FC =
  function LineAdsIntegrationPageWrapper() {
    const enableLineAdsIntegration = useEnableLineAdsIntegration();
    if (!enableLineAdsIntegration) {
      return <Navigate to="/applications" replace />;
    }
    return <LineAdsIntegrationPage />;
  };
